module.exports = __webpack_public_path__ + "static/img/100827.05657dba.png";